const SHARED_DOCUMENT_NAMESPACES = [
    'activityLog',
    'agreement',
    'billing',
    'clientFlow',
    'common',
    'errors',
    'invoice',
    'service'
];
const WEB_ONLY_EXTENSIONS_OF_SHARED_NAMESPACES = [
    'activityLogWeb',
    'agreementWeb',
    'billingWeb',
    'clientFlowWeb',
    'commonWeb',
    'errorsWeb',
    'invoiceWeb',
    'serviceWeb'
];
export const recipes = {
    frontend: [
        ...SHARED_DOCUMENT_NAMESPACES,
        ...WEB_ONLY_EXTENSIONS_OF_SHARED_NAMESPACES,
        'ai',
        'auth',
        'client',
        'home',
        'integrations',
        'navigation',
        'notification',
        'payment',
        'proposal',
        'referenceFields',
        'reports',
        'settings',
        'test',
        'vendorOnboarding'
    ],
    scoutPdf: SHARED_DOCUMENT_NAMESPACES
};
